export function fetchAllData() {
  return dispatch => {
    fetch(`https://corona.lmao.ninja/countries/`)
      .then(res => res.json())
      .then(data => {
        dispatch({
          type: "DATA",
          data
        });
      });
  };
}

export function fetchCountryData(countryname) {
  return dispatch => {
    fetch(`https://corona.lmao.ninja/countries/${countryname}`)
      .then(res => res.json())
      .then(data => {
        // console.log("data in action", data)
        dispatch({
          type: "COUNTRY_DATA",
          data
        });
      });
  };
}

export function setCountryName(data) {
	return {
		type: "COUNTRY",
		data
	}
}

export function fetchStatesDataOfIndia() {
  return dispatch => {
    fetch(`https://api.covid19india.org/data.json`)
      .then(res => res.json())
      .then(data => {
        dispatch({
          type: "INDIA_STATES_DATA",
          data: data.statewise
        });
      });
  };
}

export function fetchDistrictDataOfState() {
  return dispatch => {
    fetch(`https://api.covid19india.org/state_district_wise.json`)
      .then(res => res.json())
      .then(data => {
        dispatch({
          type: "DISTRICTS_DATA",
          data
        });
      });
  };
}

